/** @jsx jsx */
import React from "react";
import { grayScale } from "components/styles";
import Accordion from "components/molecules/Accordion";
import DataTable from "components/organismos/DataTable/DataTable";
import { css, jsx } from "@emotion/core";
import moment from "moment";
import ApprovedHolidayDomain from "../domain/approvedHolidayDomain";
import { useApplyingTransferForm } from "../ApplyingTab/hook";
import IconLabelButton from "components/molecules/IconLabelButton";
import Modal from "components/molecules/Modal";
import ChangeLogModal from "components/molecules/ChangeLogModal";
import TextTooltip from "components/molecules/TextTooltip";
 
const HolidayAccordion: React.FC<{ list: ApprovedHolidayDomain[] }> = ({
  list,
}) => {
  const {
    changeLogData,
    setChangeLogData,
    changeLogModalOpen,
    setChangeLogModalOpen,
    setSelectChangelog,
    fetchChangeLogHoliday,
  } = useApplyingTransferForm(list);
  const columns = React.useMemo(
    () => [
      // {
      //   Header: '承認者',
      //   accessor: 'authorizer',
      // },
      {
        Header: "承認日時",
        accessor: "approvalDate",
        isSorted: true,
        Cell: (cell: { row: { isExpanded: boolean; original: any } }) => (
          <div style={{ textAlign: "center" }}>
            {cell.row.original.approvalDate}
          </div>
        ),
      },
      {
        Header: "申請者",
        accessor: "applicant",
        Cell: (cell: { row: { isExpanded: boolean; original: any } }) => (
          <div style={{ textAlign: "left" }}>
            {cell.row.original.staffCode}<br></br>{cell.row.original.staffName}
          </div>
        )
      },
      {
        Header: "申請日時",
        accessor: "applicationDate",
      },
      {
        Header: "対象者",
        accessor: "targetPerson",
        Cell: (cell: { row: { isExpanded: boolean; original: any } }) => (
          <div style={{ textAlign: "left" }}>
            {cell.row.original.staffCode}<br></br>{cell.row.original.staffName}
          </div>
        )
      },
      {
        Header: (any: any) => "対象日付",
        id: "",
        accessor: "targetDate",
        Cell: (cell: {
          row: { isExpanded: boolean; original: any; index: number };
          data: any;
        }) => {
          return (
            <div style={{ textAlign: "center" }}>
              <div>
                <div>{cell.row.original.targetDate}</div>
                <IconLabelButton
                  onClick={() => {
                    fetchChangeLogHoliday(
                      cell.row.original.modifierApplicationId
                    );
                    setChangeLogModalOpen(true);
                    setSelectChangelog("0");
                  }}
                  text="更新履歴"
                  textAlign="center"
                  isIcon={false}
                />
              </div>
            </div>
          );
        },
      },
      {
        Header: "申請\n種別",
        accessor: "modifiyStatusName",
      },
      {
        Header: "休暇",
        accessor: "holidayName",
      },
      {
        Header: "休暇\n単位",
        accessor: "holidayDigestiveUnitName",
      },
      {
        Header: "開始\n時間",
        accessor: "holidayStartHm",
        Cell: (cell: { row: { isExpanded: boolean; original: any } }) => (
          <div style={{ textAlign: "center" }}>
            {(() => {
              if (
                (cell.row.original.holidayDigestiveUnit == 2 || cell.row.original.holidayDigestiveUnit == 3 || cell.row.original.holidayDigestiveUnit == 4 ) &&
                cell.row.original.holidayStartHm
              ) {
                if (
                  moment(cell.row.original.holidayStartHm).format(
                    "YYYYMMDD"
                  ) !== moment(cell.row.original.targetDate).format("YYYYMMDD")
                ) {
                  return `${moment(cell.row.original.holidayStartHm).format(
                    "HH:mm"
                  )}(翌)`;
                }
                return moment(cell.row.original.holidayStartHm).format("HH:mm");
              }
              return "";
            })()}
          </div>
        ),
      },
      {
        Header: "終了\n時間",
        accessor: "holidayEndHm",
        Cell: (cell: { row: { isExpanded: boolean; original: any } }) => (
          <div style={{ textAlign: "center" }}>
            {(() => {
              if (
                (cell.row.original.holidayDigestiveUnit == 2 || cell.row.original.holidayDigestiveUnit == 3 || cell.row.original.holidayDigestiveUnit == 4 ) &&
                cell.row.original.holidayEndHm
              ) {
                if (
                  moment(cell.row.original.holidayEndHm).format(
                    "YYYYMMDD"
                  ) !== moment(cell.row.original.targetDate).format("YYYYMMDD")
                ) {
                  return `${moment(cell.row.original.holidayEndHm).format(
                    "HH:mm"
                  )}(翌)`;
                }
                return moment(cell.row.original.holidayEndHm).format("HH:mm");
              }
              return "";
            })()}
          </div>
        ),
      },
      {
        Header: "取得\n時間",
        accessor: "holidayTimes",
        Cell: (cell: { row: { isExpanded: boolean; original: any } }) => (
          <div style={{ textAlign: "center", width: '50px' }}>
            {cell.row.original.holidayTimes
              ? `${cell.row.original.holidayTimes}時間`
              : ""}
          </div>
        ),
      },
      {
        Header: "申請理由",
        accessor: "applicationReason",
        Cell: (cell: {row: { isExpanded: boolean; original: any }})=>(
          <TextTooltip text={cell.row.original?.applicationReason} textDis={(
            <div className="ellipsis headline-cell-width-100"
              style={{
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                width: '100px'
              }}>
                {cell.row.original?.applicationReason}
            </div>
          )} />  
        )
      },
    ],
    [fetchChangeLogHoliday, setChangeLogModalOpen, setSelectChangelog]
  );

  return (
    <React.Fragment>
    <div className="margin-accordian"
      css={css`
      table th:nth-of-type(1) {
        width: 80px;
      }
      table th:nth-of-type(2) {
        width: 120px;
      }
      table td:nth-of-type(2) {
        white-space: pre-line;
      }
      table th:nth-of-type(3) {
        width: 80px;
      }
      table tbody tr td:nth-of-type(3) {
        text-align: center;
      }
      table th:nth-of-type(4) {
        width: 120px;
      }
      table td:nth-of-type(4) {
        white-space: pre-line;
      }
      table th:nth-of-type(5) {
        width: 80px;
      }
      table th:nth-of-type(6) {
        width: 55px;
        white-space: pre;
      }
      table th:nth-of-type(6) span{
        display:block;
        margin: auto;
      }
      table th:nth-of-type(6) span svg {
        margin-left: 0!important;
      }
      table th:nth-of-type(7) {
        width: 80px;
      }
      table th:nth-of-type(8) {
        width: 55px;
        white-space: pre;
      }
      table th:nth-of-type(8) span{
        display:block;
        margin: auto;
      }
      table th:nth-of-type(8) span svg {
        margin-left: 0!important;
      }
      table th:nth-of-type(9) {
        width: 55px;
        white-space: pre;
      }
      table th:nth-of-type(9) span{
        display:block;
        margin: auto;
      }
      table th:nth-of-type(9) span svg {
        margin-left: 0!important;
      }
      table th:nth-of-type(10) {
        width: 55px;
        white-space: pre;
      }
      table th:nth-of-type(10) span{
        display:block;
        margin: auto;
      }
      table th:nth-of-type(10) span svg {
        margin-left: 0!important;
      }
      table th:nth-of-type(11) {
        width: 55px;
        white-space: pre;
      }
      table th:nth-of-type(11) span{
        display:block;
        margin: auto;
      }
      table th:nth-of-type(11) span svg {
        margin-left: 0!important;
      }
      table th:nth-of-type(12) {
        width: 100px;
      }
      `}
    >
      <Accordion
        text={`休暇申請 (${list.length}件）`}
        callBack={() => {}}
        >
          <div style={{ overflowX: "auto", whiteSpace: "nowrap", padding:'0 10px 10px' }}>
            <DataTable
              columns={columns}
              classNameParrant="border-left-right border-bottom"
              className="table-no-border-left-right"
              data={list}
              isGlobalFilter={true}
              minWidth="100%"
              sortBy={[{ id: "approvalDate", desc: true }]}
            />
          </div>
        </Accordion>
      </div>
      {/* Change log  */}
      <div css={css(">div>div{ width: 1000px }")}>
        <Modal
          closeHandler={() => {
            setChangeLogModalOpen(false);
            setChangeLogData([]);
          }}
          open={changeLogModalOpen}
          title="更新履歴"
          submitText="閉じる"
          onSubmit={() => {
            setChangeLogModalOpen(false);
            setChangeLogData([]);
          }}
          closeText=""
        >
          <ChangeLogModal changeLogData={changeLogData} isStamp={true} request='休暇申請'/>
        </Modal>
      </div>
      {/* ./Change log  */}
    </React.Fragment>
  );
};

export default HolidayAccordion;
